module.exports = __webpack_public_path__ + "static/media/doc4.c64e1518.jpg";